// const orderStatus = [
//     {
//         "text": "待付款",
//         "value": "WAIT_BUYER_PAY"
//     },
//     {
//         "text": "待发货",
//         "value": "WAIT_SELLER_SEND_GOODS"
//     },
//     {
//         "text": "已发货",
//         "value": "WAIT_BUYER_CONFIRM_GOODS"
//     },
//     {
//         "text": "已取消",
//         "value": "TRADE_CLOSED_BY_TAOBAO"
//     },
//     {
//         "text": "退货中",
//         "value": "REFUNDING"
//     },
//     {
//         "text": "已退款",
//         "value": "TRADE_CLOSED"
//     },
//     {
//         "text": "已退款",
//         "value": "TRADE_CLOSED"
//     },
//     {
//         "text": "已完成",
//         "value": "TRADE_FINISHED"
//     },
// ]
// 订单状态
export const OrderStatus = {
  WAIT_BUYER_PAY: "WAIT_BUYER_PAY",
  WAIT_SELLER_SEND_GOODS: "WAIT_SELLER_SEND_GOODS",
  WAIT_BUYER_CONFIRM_GOODS: "WAIT_BUYER_CONFIRM_GOODS",
  TRADE_CLOSED_BY_TAOBAO: "TRADE_CLOSED_BY_TAOBAO",
  REFUNDING: "REFUNDING",
  TRADE_CLOSED: "TRADE_CLOSED",
  TRADE_FINISHED: "TRADE_FINISHED",
  AFTERSALE_AUDIT: "AFTERSALE_AUDIT",
};

// 售后状态
export const AfterSalesOrderStatus = {
  AFTERSALE_AUDIT: 'AFTERSALE_AUDIT', // 售后审核中 | 买家提交申请，等待商家审核
  AFTERSALE_REFUSED: 'AFTERSALE_REFUSED', // 已拒绝 | 商家审核不通过
  AFTERSALE_CLOSED: 'AFTERSALE_CLOSED', // 已关闭 | 拦截发货失败售后单关闭
  AFTERSALE_INTERCEPT: 'AFTERSALE_INTERCEPT', // 售后处理中（拦截发货）| 审核通过，等待拦截发货处理
  AFTERSALE_RETURN_GOODS: 'AFTERSALE_RETURN_GOODS', // 售后处理中（寄回商品） |审核通过，买家寄回商品中
  AFTERSALE_SELLER_REFUND: 'AFTERSALE_SELLER_REFUND', // 售后处理中（商家退款) |  审核通过，退款中
  AFTERSALE_REFUND_SUCCESS: 'AFTERSALE_REFUND_SUCCESS', // 已退款（退款完成）| 退款完成，售后结束
  AFTERSALE: 'AFTERSALE', // 售后处理中
  rejected: 'rejected', // 已拒绝
  refunded: 'refunded', // 已完成
  REFUNDING: 'REFUNDING', // 退货中
};
const AFTER_SALES_STATUSES = [
  AfterSalesOrderStatus.AFTERSALE_AUDIT,
  AfterSalesOrderStatus.AFTERSALE_INTERCEPT,
  AfterSalesOrderStatus.AFTERSALE_REFUSED,
  AfterSalesOrderStatus.AFTERSALE_RETURN_GOODS,
  AfterSalesOrderStatus.AFTERSALE_SELLER_REFUND,
  AfterSalesOrderStatus.AFTERSALE_REFUND_SUCCESS,
  AfterSalesOrderStatus.AFTERSALE_CLOSED,
  AfterSalesOrderStatus.AFTERSALE,
  AfterSalesOrderStatus.rejected,
  AfterSalesOrderStatus.refunded,
  AfterSalesOrderStatus.REFUNDING,
];

// buttonType： primary | dashed | link | text | default
// 订单详情页按钮组
export const getOrderButtonGroup = (props) => {
  const { status_code = "", channel = 'web', isMob = false, is_rma = 0 } = props;
  if (channel === 'mp') return []
  switch (status_code) {
    case OrderStatus.WAIT_BUYER_PAY:
      return isMob  && channel === 'web' ? [{ action: 'pay', buttonType: 'primary', text: '立即支付' }] : []
    case OrderStatus.WAIT_SELLER_SEND_GOODS:
      return [
        ...(is_rma === 1 ? [{ action: "applyAfterSales", buttonType: "default", text: "申请售后" }] : [])
      ];
    case OrderStatus.WAIT_BUYER_CONFIRM_GOODS:
      return [
        ...(is_rma === 1 ? [{ action: "applyAfterSales", buttonType: "default", text: "申请售后" }] : []),
        { action: "confirmReceipt", buttonType: "primary", text: "确认收货" },
      ];
    case OrderStatus.TRADE_FINISHED:
      return [
        { action: "applyInvoice", buttonType: "default", text: "申请开票", openType: 'contact' },
        ...(is_rma === 1 ? [{ action: "applyAfterSales", buttonType: "default", text: "申请售后" }] : []),
      ];
    case OrderStatus.REFUNDING:
      return [];
    case OrderStatus.TRADE_CLOSED:
      return [];
    default:
      return [];
  }
};
// 订单列表页按钮组
export const getOrderListItemButtonGroup = (props) => {
  const { status_code = "", is_rma = 0, status = '', channel = 'web' } = props;
  if (AFTER_SALES_STATUSES.includes(status_code)) {
    return [
      { action: "contact", buttonType: "default", text: "联系客服", openType: 'contact' },
      status === 'AfterSales' ? { action: "goAfterSalesDetail", buttonType: "default", text: "售后详情" } :
        { action: "goDetail", buttonType: "default", text: "查看详情" },
    ];
  }
  switch (status_code) {
    // 待付款
    case OrderStatus.WAIT_BUYER_PAY:
      return [
        { action: "goDetail", buttonType: "default", text: "查看详情" },
        ...(channel === 'web' ? [{ action: "orderPay", buttonType: "primary", text: "立即支付" }] : []),
      ];
    // 已取消
    case OrderStatus.TRADE_CLOSED_BY_TAOBAO:
      return [
        { action: "goDetail", buttonType: "default", text: "查看详情" },
      ];
    // 待发货
    case OrderStatus.WAIT_SELLER_SEND_GOODS:
      return [
        { action: "goDetail", buttonType: "default", text: "查看详情" },
        ...(is_rma === 1 ? [{ action: "applyAfterSales", buttonType: "default", text: "申请售后" }] : [])
      ];
    // 待收货 | 已发货
    case OrderStatus.WAIT_BUYER_CONFIRM_GOODS:
      return [
        { action: "goDetail", buttonType: "default", text: "查看详情" },
        { action: "confirmReceipt", buttonType: "primary", text: "确认收货" },
      ];
    // 已完成
    case OrderStatus.TRADE_FINISHED:
      return [
        { action: "goDetail", buttonType: "default", text: "查看详情" },
        ...(is_rma === 1 ? [{ action: "applyAfterSales", buttonType: "default", text: "申请售后" }] : [])
      ];
    default:
      return [
        { action: "goDetail", buttonType: "default", text: "查看详情" },
      ];
  }
};

// 获取售后审核流程
export const getAfterSalesFlow = (status) => {
  switch (status) {
    case 2:
      return [
        {
          key: 1,
          label: "售后审核",
          description: "您已提交退款申请，请耐心等待售后审核。",
          status: 'AFTERSALE_AUDIT',
          width: '18%'
        },
        { key: 2, label: "拦截发货", status: 'AFTERSALE_INTERCEPT', description: "已同意退款，系统尝试拦截发货中。", width: '50%' },
        { key: 3, label: "商家退款", status: 'AFTERSALE_SELLER_REFUND', description: "拦截发货成功，正在为您处理退款。", width: '82%' },
        { key: 4, label: "退款完成", status: 'refunded', description: "", width: '100%' },
      ];
    case 1:
      return [
        {
          key: 1,
          label: "售后审核",
          status: 'AFTERSALE_AUDIT',
          description: "您已提交退货退款申请，请耐心等待售后审核。",
          width: '18%'
        },
        {
          key: 2,
          label: "寄回商品",
          status: 'AFTERSALE_RETURN_GOODS',
          description:
            "已同意退货。请您寄回退货商品，如有防尘袋、配件、赠品、购物清单、发票等随单物品也应一同寄回，避免影响您的正常退款。",
          width: '50%'
        },
        { key: 3, label: "商家退款", status: 'AFTERSALE_SELLER_REFUND', description: "退货已入库，正在为您处理退款。", width: '82%' },
        { key: 4, label: "退款完成", status: 'refunded', description: "", width: '100%' },
      ];
    default:
      return null;
  }
};
export const AuditCompleted = (status) => {
  switch (status) {
    case AfterSalesOrderStatus.AFTERSALE_REFUND_SUCCESS:
      return {
        label: "已退款",
        description: '',
        value: status,
      };
    case AfterSalesOrderStatus.AFTERSALE_REFUSED:
      return {
        label: "已拒绝",
        description: '已与客服协商一致取消售后。如有疑问，请咨询',
        value: status,
      };
    case AfterSalesOrderStatus.AFTERSALE_CLOSED:
      return {
        label: "已关闭",
        description: '拦截发货失败，您的包裹可能正在打包出库中，详询',
        value: status,
      };
    default:
      return {
        label: "",
        description: '',
        value: status,
      };
  }
};

// 获取售后类型
export const getAfterSaleType = (status) => {
  switch (status) {
    case OrderStatus.WAIT_SELLER_SEND_GOODS:
      return {
        label: "退款",
        value: status,
        key: 2,
      };
    case OrderStatus.WAIT_BUYER_CONFIRM_GOODS:
      return {
        label: "退货退款",
        value: status,
        key: 1
      };
    default:
      return {
        label: "退货退款",
        value: status,
        key: 1
      };
  }
};

export const tabsLabel = [
  {
    key: 1,
    label: '全部订单',
    code: ''
  },
  {
    key: 2,
    label: '待付款',
    code: OrderStatus.WAIT_BUYER_PAY
  },
  {
    key: 3,
    label: '待发货',
    code: OrderStatus.WAIT_SELLER_SEND_GOODS
  },
  {
    key: 4,
    label: '待收货',
    code: OrderStatus.WAIT_BUYER_CONFIRM_GOODS
  },
  {
    key: 5,
    label: '已完成',
    code: OrderStatus.TRADE_FINISHED
  },
  {
    key: 6,
    label: '售后',
    code: 'AfterSales'
  }
]

export default {
  getAfterSalesFlow,
  OrderStatus,
  getOrderButtonGroup,
  getAfterSaleType,
  getOrderListItemButtonGroup,
  tabsLabel,
  AuditCompleted,
  AfterSalesOrderStatus
};
